import { formatBirth, type HistoryItem } from "../api";
import { IconDoc, IconStar } from "../icons";
import { LoadError, Skeleton } from "../ui";

interface Props {
  items: HistoryItem[] | null;
  failed: boolean;
  onRetry: () => void;
  onOpen: (item: HistoryItem) => void;
  onToggleFavorite: (item: HistoryItem) => void;
}

/** Вкладка «Мои разборы»: разборы, которые клиент уже открывал (последний раз — сверху). Открытие пересчитывает разбор по актуальной методике. */
export function MyReadings({ items, failed, onRetry, onOpen, onToggleFavorite }: Props) {
  const opened = items?.filter((i) => i.count > 0) ?? [];
  return (
    <div className="warm">
      <div className="pagehead">
        <h1>Мои разборы</h1>
        <p>Разборы, которые ты уже открывал</p>
      </div>
      <div className="sheet" style={{ minHeight: "60vh" }}>
        {!items && !failed && <Skeleton rows={3} tall />}
        {failed && !items && <LoadError text="Не удалось загрузить список." onRetry={onRetry} />}
        {items && opened.length === 0 && (
          <div className="empty">
            <IconDoc />
            <p style={{ marginTop: 12 }}>Пока пусто. Открой любой разбор на главной — он появится здесь.</p>
          </div>
        )}
        {opened.map((i) => (
          <ReadingRow key={i.moduleId} item={i} onOpen={onOpen} onToggleFavorite={onToggleFavorite} />
        ))}
      </div>
    </div>
  );
}

export function ReadingRow({ item, onOpen, onToggleFavorite }: { item: HistoryItem; onOpen: (i: HistoryItem) => void; onToggleFavorite: (i: HistoryItem) => void }) {
  return (
    <div className="histcard">
      <button className="histmain" onClick={() => onOpen(item)}>
        <b>{item.title}</b>
        <p>{item.summary}</p>
        {item.lastDate && <span className="histdate">Открывался: {formatBirth(item.lastDate)}</span>}
      </button>
      <button
        className={`favbtn${item.favorite ? " on" : ""}`}
        onClick={() => onToggleFavorite(item)}
        aria-label={item.favorite ? "Убрать из избранного" : "Добавить в избранное"}
        aria-pressed={item.favorite}
      >
        <IconStar />
      </button>
    </div>
  );
}
